<div class="d-flex gap-2 flex-wrap mb-3">
  <div>
    <div
      class="position-relative bg-white border text-dark text-center rounded d-flex align-items-center p-3 form-control justify-content-center fw-semibold"
      role="button"
    >
      <span
        >{{ selectedDate | customDate: "d MMM y" }} -
        {{ selectedWeekEnd | customDate: "d MMM y" }}</span
      >
      <span><i class="fa-solid fa-calendar ms-1"></i></span>

      <input
        class="hidden-calendar-lookup"
        type="date"
        [(ngModel)]="selectedDate"
        (change)="onSelectedDateChange()"
      />
    </div>
    <!-- <div class="form-floating">
        <input
          class="form-control"
          type="date"
          placeholder="Pick Date"
          [(ngModel)]="selectedDate"
          (change)="onSelectedDateChange()"
        />
        <label>Pick Date</label>
      </div> -->
  </div>

  <div
    (click)="changeWeek('-')"
    class="border rounded p-2 d-flex align-items-center text-secondary"
    role="button"
  >
    <i class="fa-solid fa-caret-left fs-3"></i>
  </div>
  <div
    (click)="changeWeek('+')"
    class="border rounded p-2 d-flex align-items-center text-secondary"
    role="button"
  >
    <i class="fa-solid fa-caret-right fs-3"></i>
  </div>

  @if (currentMonday != selectedDate && largeView) {
    <div
      class="d-flex gap-1 flex-wrap justify-content-center justify-content-lg-start"
    >
      <div
        class="border rounded py-lg-2 px-lg-5 d-flex align-items-center text-secondary gap-2 px-5 py-2 small text-uppercase fw-semibold justify-content-center"
        (click)="changeWeek('today')"
        role="button"
      >
        Today
      </div>
    </div>
  }

  <div>
    <gtapp-user-lookup
      (onSelectUserEvent)="onSelectUser($event)"
    ></gtapp-user-lookup>
  </div>
</div>

@if (userLeaveData?.length > 1) {
  <div class="mb-3 d-flex gap-3 p-2 text-primary align-items-center">
    <input
      class="form-check-input"
      type="checkbox"
      [checked]="userLeaveData?.length == selectedItemIds.size"
      (change)="onSelectItem($event)"
      id="selectAllBox"
    />
    <label for="selectAllBox" class="mt-1"
      >Select All [{{ userLeaveData?.length }}]</label
    >
    @if (selectedItemIds.size) {
      <div class="d-flex gap-4">
        <span (click)="onStatusChange(1)">
          <i class="fa-solid fa-check text-success fa-2x"></i>
        </span>
        <span (click)="onStatusChange(2)">
          <i class="fa-solid fa-xmark text-danger fa-2x"></i>
        </span>
      </div>
    }
  </div>
}
<div class="custom-scroll" [style.max-height.vh]="largeView ? 80 : 55">
  <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4">
    @for (leave of userLeaveData; track $index) {
      <div class="col">
        <div class="bg-secondary-subtle text-dark rounded p-2 p-lg-3">
          <div class="d-flex gap-2">
            <input
              class="form-check-input"
              type="checkbox"
              [checked]="selectedItemIds.has(leave?.id)"
              (change)="onSelectItem($event, leave)"
              id="selectAllBox"
            />
            <div class="flex-grow-1 pb-2">
              <div class="d-flex gap-4 flex-wrap justify-content-between mb-2">
                @if (!selectedUser?.id) {
                  <div>
                    {{ leave?.assignee_name }}
                  </div>
                }
                <div>
                  {{ leave?.leave_date | customDate: "d MMM y" }}
                </div>
              </div>

              <div class="small mb-3">
                {{ leave?.leave_reason }}
              </div>
              @switch (leave?.leave_status) {
                @case (0) {
                  @if (!selectedItemIds.size) {
                    <div class="d-flex gap-4">
                      <span (click)="onStatusChange(1, leave)">
                        <i class="fa-solid fa-check text-success fa-2x"></i>
                      </span>
                      <span (click)="onStatusChange(2, leave)">
                        <i class="fa-solid fa-xmark text-danger fa-2x"></i>
                      </span>
                    </div>
                  }
                }
                @case (1) {
                  <span
                    class="bg-success p-1 px-2 rounded text-white small-font"
                    >Approved</span
                  >
                }
                @case (2) {
                  <span class="bg-danger p-1 px-2 rounded text-white small-font"
                    >Rejected</span
                  >
                }
              }
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
@if (totalRowsLeaveData) {
  <div class="mt-2">
    <gtapp-pagination-control
      [pageSize]="rowsLeaveData"
      [pageNum]="pageNumLeaveData"
      [previous]="previousLeaveData"
      [totalRows]="totalRowsLeaveData"
      (onChangePagination)="onChangePagination($event)"
    >
    </gtapp-pagination-control>
  </div>
}
